import styles from './style.module.css'
import { FiDownloadCloud } from 'react-icons/fi'
import Moment from 'react-moment';
import { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom';
import api from '../../api';
import { Breadcrumbs, PreLoader } from '../index'

function SingleNewsCard() {
    const [loading, setLoading] = useState(false);
    const { id } = useParams();
    const [newsSingle, setNewsSingle] = useState([])

    useEffect(_ => {
        setLoading(true);
        api.getSingleNews({
            news_id: id
        })
            .then(res => {
                setLoading(false);
                setNewsSingle(res)
            })
    }, [])
    return (
        <div className={styles.single_news}>
            {loading ? (
                <PreLoader />
            ) : (
                <div className={styles.single_news__row}>
                    <Breadcrumbs urls={[{ title: 'Новости', path: '/news' }, { title: newsSingle.title, path: '' }]} />
                    <div className={styles.title}>{newsSingle.title}</div>
                    <div className={styles.tags}>{newsSingle.tags?.map((tag) => { return (<ul><li>{tag.name}</li></ul>) })}</div>
                    {newsSingle.title_img ? (
                        <div className={styles.img}>
                            <img
                                src={newsSingle.title_img}
                                alt={newsSingle.title}
                            />
                        </div>
                    ) : null}
                    <div className={styles.content} dangerouslySetInnerHTML={{ __html: newsSingle.text }}></div>
                    {newsSingle.news_document?.map((doc, i) => {
                        return (
                            <span key={i} className={styles.doc}>
                                <a target='blank' href={doc.file}><span>{doc.title}</span> <FiDownloadCloud /></a>
                            </span>
                        )
                    })}
                    <div className={styles.date}>
                        <Moment className={styles.news__announ__date} locale='ru' format='LL'>
                            {newsSingle.pub_date}
                        </Moment></div>
                </div>
            )}
        </div>
    )
}
export default SingleNewsCard;